export default "__VITE_ASSET__b1fa6b4b__"